import { IconProps } from "../../utils/global-types/global-types";

const PasswordIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M13.5 7H13V5C13 2.794 11.206 1 9 1C6.794 1 5 2.794 5 5V7H4.5C3.67333 7 3 7.67267 3 8.5V15.5C3 16.3273 3.67333 17 4.5 17H13.5C14.3267 17 15 16.3273 15 15.5V8.5C15 7.67267 14.3267 7 13.5 7ZM6.33333 5C6.33333 3.52933 7.52933 2.33333 9 2.33333C10.4707 2.33333 11.6667 3.52933 11.6667 5V7H6.33333V5ZM9.66667 12.148V13.6667C9.66667 14.0347 9.36867 14.3333 9 14.3333C8.63133 14.3333 8.33333 14.0347 8.33333 13.6667V12.148C7.93667 11.9167 7.66667 11.4913 7.66667 11C7.66667 10.2647 8.26467 9.66667 9 9.66667C9.73533 9.66667 10.3333 10.2647 10.3333 11C10.3333 11.4913 10.0633 11.9167 9.66667 12.148Z"
      />
    </svg>
  );
};

export default PasswordIcon;
